import { Button } from "@design-system/components/Button";
import { trans } from "@mongez/localization";
import { useSubmitPayment } from "../hooks";

export function PaymentSubmitButton() {
  const { submit, canSubmit, isProcessing } = useSubmitPayment();

  return (
    <Button
      onClick={submit}
      disabled={!canSubmit || isProcessing}
      isLoading={isProcessing}
      className="flex-1"
    >
      {isProcessing
        ? trans("invoices.processing")
        : trans("invoices.completePayment")}
    </Button>
  );
}
